import { Component, Input } from '@angular/core';
import { HxUiLabelPipe, InvoiceProductModel } from 'hx-services';

@Component({
    selector: 'app-invoice-product',
    templateUrl: './invoice-product.component.html',
    styleUrls: ['./invoice-product.component.css'],
  imports: [
    HxUiLabelPipe
  ]
})
export class InvoiceProductComponent {
  @Input() product!: InvoiceProductModel;
}
